import { Pie, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

const { reactiveProp } = mixins;

export default {
	extends: Pie,
	mixins: [reactiveProp],
	props: ['options'],
	mounted() {
		this.addPlugin(ChartDataLabels); //차트 내에 값 표시를 위해 필요한 플러그인
		this.renderChart(this.chartData, this.options);
	}
};
